import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { SettingModule } from "@/store/modules/settings.module";
import { strictDateFormatter } from "@/utilities/strictDateFormatter";
/**
 * CRM date pickers: strict parsing of typed dates plus an inline message for a rejected entry.
 *
 * On each <date-picker>:
 *   :formatter="strictDateFormatter" @input-error="rejectDate('key', $event)" @change="acceptDate('key')"
 * and under it:
 *   <div class="invalid-feedback d-block" v-if="dateError('key')">{{ dateError('key') }}</div>
 * Save/Update should stop while `hasDateErrors` is true.
 */
let StrictDateMixin = /** @class */ (() => {
    let StrictDateMixin = class StrictDateMixin extends Vue {
        constructor() {
            super(...arguments);
            this.strictDateFormatter = strictDateFormatter;
            // Rejected typed text per picker key; cleared when that picker accepts a value
            this.dateInputErrors = {};
        }
        // The picker reverts its text after a rejection, so the message repeats what was typed
        rejectDate(key, text) {
            const format = SettingModule.userDateFormat;
            this.$set(this.dateInputErrors, key, `“${text}” isn't a valid date or isn't allowed here. Use ${format}.`);
        }
        acceptDate(key) {
            if (this.dateInputErrors[key]) {
                this.$delete(this.dateInputErrors, key);
            }
        }
        dateError(key) {
            return this.dateInputErrors[key] || "";
        }
        // For pickers whose form closes and reopens without being re-created (modals on a tab)
        clearDateErrors() {
            this.dateInputErrors = {};
        }
        get hasDateErrors() {
            return Object.keys(this.dateInputErrors).length > 0;
        }
    };
    StrictDateMixin = __decorate([
        Component
    ], StrictDateMixin);
    return StrictDateMixin;
})();
export default StrictDateMixin;
